import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleNavigate } from "../hooks/handleNavigate";
// [A형] ParagraphSelector/SectionSelector(2단계) → EntrySelector(한 화면 통합)로 교체.
// 두 원본 파일은 롤백 대비 레포에 보존한다.
import EntrySelector from "../features/assignment/components/common/EntrySelector";

import {
  fetchParagraphList,
  fetchSectionList,
  retreiveAssignment,
  setParagraph,
  setSection,
} from "../features/assignment/assignmentSlice";
import { checkStudent } from "../features/student/studentSlice";
import TopBar from "../features/assignment/components/widgets/TopBar";
import SectionPage from "../features/assignment/components/common/SectionPage";
import "./StudyPage.css";

const AssignmentPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.student);
  const { paragraphList, sectionList, assignment } = useSelector(
    (state) => {
      const assignment = state.assignment;

      // make paragraphList's first element to last,
      // when assignment.assignment.is_retry is true

      if (assignment?.assignment?.is_retry) {
        // Avoid mutating the original array since it may be frozen or non-extensible.
        const paragraphList = assignment.paragraphList;
        const rotatedParagraphList = paragraphList.length > 0
          ? [...paragraphList.slice(1), paragraphList[0]]
          : [];

        return {
          ...assignment,
          paragraphList: rotatedParagraphList,
        };
      }

      return assignment;
    }
  );
  const [selectedParagraph, setSelectedParagraph] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  // [레이스 수정] SPA에서 과제 A→B 연속 진입 시 redux에 A의 paragraphList가 남아
  // 있는데, EntrySelector 자동선택이 그 낡은 목록을 집어 B 화면에 A의 섹션이
  // 뜨는 버그가 있었다("내용이해 메뉴가 모의고사에 나옴"). 이번 과제의
  // fetchParagraphList가 끝난 뒤에만 진입 화면을 활성화한다.
  const [entryReady, setEntryReady] = useState(false);
  // 세션 확인이 끝나기 전에는 알림장으로 돌려보내지 않는다.
  const [sessionChecked, setSessionChecked] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const assignmentId = queryParams.get("id");
    const session = queryParams.get("session");

    // 이 화면을 새로고침하면 redux 가 비어 있으므로 여기서도 세션을 확인한다.
    // 예전에는 확인하지 않고 곧바로 알림장으로 돌려보내서, 과제 링크를 새로고침하면
    // 풀던 과제에서 튕겨 나갔다.
    if (session) {
      try {
        const [studentId, randomCode] = atob(session).split(":");
        dispatch(checkStudent({ studentId, randomCode })).finally(() =>
          setSessionChecked(true)
        );
      } catch (error) {
        setSessionChecked(true);
        alert("잘못된 URL입니다.");
      }
    } else {
      setSessionChecked(true);
      alert("잘못된 URL입니다.");
    }

    if (assignmentId) {
      try {
        // 과제 자체도 받아 둔다. 목록에서 눌러 들어오면 redux 에 이미 있지만,
        // 이 주소로 바로 들어오거나 새로고침하면 비어 있다. 섹션 목록을 정렬할 때
        // 과제 유형을 보기 때문에, 없으면 그 자리에서 터진다.
        dispatch(retreiveAssignment(assignmentId));
        dispatch(fetchParagraphList(assignmentId)).then(() => setEntryReady(true));
      } catch (error) {
        alert("잘못된 URL입니다.");
      }
    } else {
      alert("잘못된 URL입니다.");
    }
  }, [dispatch]);

  useEffect(() => {
    if (sessionChecked && !isAuthenticated) {
      handleNavigate({ url: "/home", params: {}, navigate });
    }
  }, [sessionChecked, isAuthenticated, navigate]);

  // [A형] 지문 행 클릭 = 기존 "다음" 버튼(handleCompleteParagraphSelection)의
  // 몸통(setParagraph + fetchSectionList)을 그대로 클릭 시점으로 이동.
  const handleSelectParagraph = (paragraph) => {
    setSelectedParagraph(paragraph);
    dispatch(setParagraph(paragraph));
    dispatch(fetchSectionList(paragraph.id));
  };

  // [A형] 섹션 행 클릭 = 기존 "학습하기" 버튼(handleCompleteSectionSelection)의
  // 몸통(setSection + setCurrentStep(3))을 그대로 클릭 시점으로 이동.
  const handleEnterSection = (section) => {
    dispatch(setSection(section));
    setSelectedSection(null);
    setCurrentStep(3);
  };

  const renderContent = () => {
    // [A형] step 1과 2를 모두 EntrySelector로 렌더한다.
    // 각 학습 화면은 완료 시 setCurrentStep(2)로 "섹션 선택 복귀"를 호출하는데,
    // 2를 함께 매핑하면 그 호출들이 그대로 통합 진입 화면 복귀가 되어
    // 학습 컴포넌트 수정이 0개가 된다.
    if (currentStep === 1 || currentStep === 2) {
      return (
        <EntrySelector
          entryReady={entryReady}
          paragraphList={paragraphList}
          sectionList={sectionList}
          selectedParagraph={selectedParagraph}
          onSelectParagraph={handleSelectParagraph}
          onEnterSection={handleEnterSection}
        />
      );
    }
    return <SectionPage setCurrentStep={setCurrentStep} />;
  };

  return (
    <div
      className="study-page"
      onContextMenu={(e) => {
        e.preventDefault();
      }}
    >
      <div className="study-page__column">
        <TopBar currentStep={currentStep} setCurrentStep={setCurrentStep} />
        {renderContent()}
      </div>
    </div>
  );
};

export default AssignmentPage;
